// @ts-nocheck
import { Plugin } from '/home/ckpt/workspace/front_package_tools_online_正式_pro/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','locale','request',],
});

export { plugin };
